import { useStartProviderApplyPath } from "@/composition"
import type { RouteRecordRaw } from "vue-router"

import { FloorDecorRoutes } from "@/groups/FloorDecor/routes"

export const GroupRoutes: RouteRecordRaw[] = [
  {
    name: "default-group-start-route",
    path: ":group/start",
    redirect: () => useStartProviderApplyPath().value,
  },
  ...FloorDecorRoutes,
]
